export default "__VITE_ASSET__C4sY1gHk__"